import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useAssetTransfersStore = defineStore('assetTransfers', {
  state: () => ({
    data: undefined,
    options: undefined,
  }),
  getters: {
    getAssetTransfers: (state) => state.data?.data,
    getAssetTransferOptions: (state) => state.options?.data,
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param params
     * @param silent
     * @returns {Promise<any>}
     */
    async indexAssetTransferOptions(params = {}, silent = true) {

      if (!silent)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params, 'asset_transfers', ['id', 'name', 'company_id']);
          const response = await axios.get('asset-transfers', {params: qryParams});
          this.options = response.data;
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexAssetTransfers(params = {}) {
      try {
        const response = await axios.get('asset-transfers', {params});
        this.data = response.data;
        return this.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createAssetTransfer(params = {}) {
      try {
        const response = await axios.get('asset-transfers/create', {params});
        return useCreateForm('asset-transfers', response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showAssetTransfer(assetTransferId, params = {}) {
      try {
        const response = await axios.get(`asset-transfers/${ assetTransferId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editAssetTransfer(assetTransferId, params = {}) {
      try {
        const response = await axios.get(`asset-transfers/${ assetTransferId }/edit`, {params});
        return useEditForm(`asset-transfers/${ assetTransferId }`, response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
